import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, Link, useParams } from "react-router-dom";

import Box from '@mui/material/Box';
import { Button, Card } from '@mui/material';
import FileUploader from "../../FileUploader";

import { endpoints } from "../../../services/apiurl";
import Input from "../../UI/Input/Input";
import PageTitle from "../../UI/PageTitle";
import DeleteIcon from '@mui/icons-material/Delete';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';

const EditSlider = () => {
    let history = useHistory();
    let { id } = useParams();

    const [cat, setCat] = useState({
        status: '',
        image: '',
        iconName: '',
        heading: '',
        subheading: ''
    });
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setloading] = useState(false);

    const { status, image, iconName, heading, subheading } = cat;
    const onInputChange = e => {
        setCat({ ...cat, [e.target.name]: e.target.value })
        console.log(cat);
    }

    useEffect(() => {
        editcategory();
    }, []);

    const editcategory = async () => {
        await axios.post(endpoints.editSlider, { id: id }).then((response) => {
            setCat({
                id: response.data.data.id,
                status: response.data.data.status,
                image: response.data.data.image,
                heading: response.data.data.heading,
                subheading: response.data.data.subheading,
                iconName: response.data.data.iconName
            });
        });
    }

    const removeImageHandler = async (id) => {
        await axios.post(endpoints.deleteSliderImage, { id }).then((response) => {
        });
        window.location.reload();
    };

    const onSubmit = async e => {
        setloading(true);
        e.preventDefault();
        const formData = new FormData();
        formData.append("heading", heading);
        formData.append("subheading", subheading);
        formData.append("image", selectedFile);
        formData.append("status", status);
        formData.append("id", id);


        try{
            const response = await axios.post(endpoints.updateSlider, formData);
            setloading(false);
            history.goBack();
            if (response.data && response.data.status === true) {
                toast.success('Slider Updated Successfully!', {
                  position: 'top-right',
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: 'colored',
                });
              } else {
                // Handle other cases if needed
              }
            } catch (error) {
              console.error('Error during Updated Slider:', error);
              setloading(false);
          
              toast.error('Error during Updated Slider. Please try again.', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored',
              });
            }
       
    }

    return (
        <div className="ui main">
            <PageTitle title="Edit Slider" linkurl="" linkTitle="" />
            <Card className="px-3 py-3">
                <form className="ui form" onSubmit={e => onSubmit(e)} encType="multipart/form-data">
                    <div className="row">
                        <Input id="heading" label="Heading" type="text" name="heading" place="Heading" onChange={(e) => onInputChange(e)}
                            requiredInput="" value={heading} class="col col-6"
                        />

                        <Input id="subheading" label="Sub Heading" type="text" name="subheading" place="Sub Heading" onChange={(e) => onInputChange(e)}
                            requiredInput="" value={subheading} class="col-6"
                        />

                    </div>
                    <div className="row">
                        <div className="col col-6">
                            <label>Status</label>
                            <select name="status" className="form-control" onChange={e => onInputChange(e)} value={status} >
                                <option value="">Select Status</option>
                                <option value="2">InActive</option>
                                <option value="1">Active</option>
                            </select>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col col-6">
                            <label>Image</label>
                            <FileUploader
                                onFileSelectSuccess={(file) => setSelectedFile(file)}
                                onFileSelectError={({ error }) => alert(error)}
                            />

                            {iconName ? (
                                <div className="mt-3">
                                    <img src={image} height="200px" width="200px" className="px-2" />
                                    <Button variant="outlined" color="error" startIcon={<DeleteIcon />} onClick={() => removeImageHandler(id)}>
                                        Delete
                                    </Button>
                                </div>
                            ) : ''}
                        </div>

                    </div>

                    <div className="row">
                        <div className="col col-6">
                            <div className="mt-3">
                                {/* <Button type="submit" variant="contained" size="large">
                                    Save
                                </Button> */}
                                <LoadingButton
                                    type="submit"
                                    loading={loading}
                                    loadingPosition="start"
                                    startIcon={<SaveIcon />}
                                    variant="contained"
                                    size="large"
                                >
                                    Save
                                </LoadingButton>
                                <ToastContainer />
                            </div></div>

                    </div>

                </form>


            </Card>

        </div>
    );

}

export default EditSlider;
